export enum Modes {
  HEIGHT = 'height',
  WIDTH = 'width',
}

export type SupportedModes = Modes.WIDTH | Modes.HEIGHT;
